import React, { JSX } from 'react';
import './Breadcrumbs.css'
import { bookTOC } from '../../data/bookTOC';
import { useLocation, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';

type BreadcrumbItem = {
  title: string;
  slug: string;
  Component: () => JSX.Element;
  path: string;
}

function findBreadcrumbs(path: string): BreadcrumbItem[] {
  for (const chapter of bookTOC) {
    const chapterPath = `/${chapter.slug}`;
    if (chapterPath === path) {
      return [{ ...chapter, path: chapterPath }];
    }

    if (chapter.subchapters) {
      for (const sub of chapter.subchapters) {
        const subPath = `${chapterPath}/${sub.slug}`;
        if (subPath === path) {
          return [
            { ...chapter, path: chapterPath },
            { ...sub, path: subPath },
          ];
        }
      }
    }
  }

  return [];
}

export function Breadcrumbs() {
  const location = useLocation();
  const crumbs = findBreadcrumbs(location.pathname);

  if (!crumbs || crumbs.length === 0) return null;

  return (
    <nav className="breadcrumbs">
      <span>
        <Link to="/">
          <FontAwesomeIcon icon={faHome} />
        </Link>
        {crumbs.length > 0}
      </span>
      {crumbs.map((crumb, i) => (
        <span key={i}>
          <Link to={crumb.path}>{crumb.title}</Link>
          {i < crumbs.length - 1}
        </span>
      ))}
    </nav>
  );
}
